import { Component, OnInit, ViewChild } from '@angular/core';
import { Routes, ActivatedRoute, Router } from '@angular/router';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { User } from 'app/shared/models/User';
import { AlertMessageComponent } from 'app/shared/components/alert-message/alert-message.component';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { Location } from '@angular/common';
import { AuditTemplateService } from 'app/audit-template/services/audit-template.service';
import { AuditTemplateDetailsModel } from 'app/audit-template/models/audit-template-details.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { Result } from 'app/core/models/result';

@Component({
    selector: 'app-company-audit-update',
    templateUrl: './company-audit-update.component.html',
    styleUrls: ['./company-audit-update.component.css']
})
export class CompanyAuditUpdateComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    @ViewChild(AlertMessageComponent, { static: false }) alertMessage: AlertMessageComponent;
    companyAuditModel: ICompanyAuditDetailsModel;
    submitAttempt: boolean = false;
    updateAuditFormGroup: FormGroup;
    companyAuditId: string;
    user: User;
    auditTemplates: AuditTemplateDetailsModel[];
    companyId: string;
    auditId: string;
    auditTemplateString: string;

    constructor(
        private companyAuditService: CompanyAuditService,
        private auditTemplateService: AuditTemplateService,
        private fb: FormBuilder,
        private location: Location,
        private activatedRoute: ActivatedRoute,
        private router: Router) { }

    ngOnInit() {

        //this.getAuditTemplatesForCompany();

        this.auditId = this.activatedRoute.snapshot.params['id'];
        this.companyAuditService.get(this.auditId).subscribe(auditInfo => {
            this.companyAuditModel = auditInfo;
            this.companyAuditModel.startDate = this.companyAuditModel.startDate ? new Date(this.companyAuditModel.startDate) : null;
            this.companyAuditModel.deadlineDate = this.companyAuditModel.deadlineDate ? new Date(this.companyAuditModel.deadlineDate) : null;
            this.companyAuditModel.completedDate = this.companyAuditModel.completedDate ? new Date(this.companyAuditModel.completedDate) : null;
            this.initializeForm(auditInfo);
            this.headerTitle = {
                title: auditInfo.title,
                breadcrumbs: [{ title: 'Company Audits', url: ['/company-audit'] }]
            };
        });

    }

    initializeForm(auditInfo): void {
        this.updateAuditFormGroup = this.fb.group(
            {
                id: [auditInfo.id],
                title: [auditInfo.title, Validators.required],
                companyId: [auditInfo.companyId],
                auditTemplateId: [auditInfo.auditTemplateId, Validators.required],
                startDate: [auditInfo.startDate, Validators.required],
                deadlineDate: [auditInfo.deadlineDate],
                auditStatus: [auditInfo.auditStatus],
                completedDate: [auditInfo.completedDate],
                isExternal: [auditInfo.isExternal],
                reviewerSummary: [auditInfo.reviewerSummary],
                reviewerSiteUserId: [auditInfo.reviewerSiteUserId],
                auditorSiteUserId: [auditInfo.auditorSiteUserId]
            }
        );
    }

    getAuditTemplatesForCompany(): void {
        this.auditTemplateService.getAllForCompany(this.companyId).subscribe(result => {
            this.auditTemplates = result;
        });
    }

    updateAudit(): void {
        this.submitAttempt = true;

        var startDate = this.updateAuditFormGroup.get('startDate').value;
        var deadlineDate = this.updateAuditFormGroup.get('deadlineDate').value;
        var completedDate = this.updateAuditFormGroup.get('completedDate').value;

        if (this.updateAuditFormGroup.valid && (!deadlineDate || startDate <= deadlineDate)) {
            const formValue = this.updateAuditFormGroup.value;

            formValue.startDate = startDate ? new Date(new Date(startDate).setHours(12)).toISOString() : null;
            formValue.deadlineDate = deadlineDate ? new Date(new Date(deadlineDate).setHours(12)).toISOString() : null;
            formValue.completedDate = completedDate ? new Date(new Date(completedDate).setHours(12)).toISOString() : null;

            this.companyAuditService.update(formValue).subscribe(
                response => {
                    this.alertMessage.showMessage();
                },
                error => {
                    this.errors = error.errorList;
                }
            );
        }

    }

    successClicked($event: any): void {
        this.router.navigate(['./company-audit']);
    }

    onHide($event: any): void { }

    onBack($event: any): void {
        this.location.back();
    }

    get title() { return this.updateAuditFormGroup.get('title'); }
    get startDate() { return this.updateAuditFormGroup.get('startDate'); }
    get deadlineDate() { return this.updateAuditFormGroup.get('deadlineDate'); }
}
